var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 69,
    viewBox: "0 0 49 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8849 5.82556H22.6482C20.8932 5.82556 19.4706 7.24821 19.4706 9.00314V22.7726C19.4706 24.5276 20.8932 25.9502 22.6482 25.9502H26.8849C28.6399 25.9502 30.0625 24.5276 30.0625 22.7726V9.00314C30.0625 7.24821 28.6399 5.82556 26.8849 5.82556ZM22.6482 0C17.6759 0 13.645 4.03084 13.645 9.00314V22.7726C13.645 27.7449 17.6759 31.7758 22.6482 31.7758H26.8849C31.8572 31.7758 35.8881 27.7449 35.8881 22.7726V9.00314C35.8881 4.03084 31.8572 0 26.8849 0H22.6482Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9601 41.6602L22.7723 41.0177C21.0377 40.7515 19.4157 41.9419 19.1496 43.6766L17.0612 57.2868C16.795 59.0214 17.9855 60.6434 19.7201 60.9095L23.9079 61.5521C25.6425 61.8182 27.2644 60.6278 27.5306 58.8932L29.6189 45.283C29.8851 43.5483 28.6947 41.9264 26.9601 41.6602ZM23.6558 35.2595C18.741 34.5054 14.1455 37.8783 13.3914 42.793L11.303 56.4032C10.5489 61.318 13.9218 65.9136 18.8366 66.6677L23.0243 67.3103C27.9391 68.0644 32.5347 64.6915 33.2888 59.7767L35.3771 46.1665C36.1312 41.2517 32.7584 36.6562 27.8436 35.9021L23.6558 35.2595Z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17438 27.483L1.87842 25.8942L2.63931 23.3579L7.93527 24.9467L7.17438 27.483Z",
    fill: "#FF5000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49523 34.0627L0.934469 34.0627L0.934469 31.4147L6.49523 31.4147L6.49523 34.0627Z",
    fill: "#FF5000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49864 40.2917L3.20268 42.0364L2.37412 39.5214L7.67009 37.7767L8.49864 40.2917Z",
    fill: "#FF5000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0346 38.3007L46.3306 39.8895L45.5697 42.4258L40.2737 40.837L41.0346 38.3007Z",
    fill: "#FF5000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7138 31.721L47.2745 31.721L47.2745 34.369L41.7138 34.369L41.7138 31.721Z",
    fill: "#FF5000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7103 25.492L45.0063 23.7472L45.8349 26.2623L40.5389 28.007L39.7103 25.492Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExpired);
export default __webpack_public_path__ + "static/media/linkExpired.a888ca9a6bec5d03853b720e0ddc90ab.svg";
export { ForwardRef as ReactComponent };